import { GlobalScope_instance2yi3ofovizf7l as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  writer1eia5its2a1fh as writer,
  writeFully3k1eaua3t4bqd as writeFully,
  close3semq7pafb42g as close,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { get_ByteArrayPool3f7yrgvqxz9ct as get_ByteArrayPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/ByteArrayPool.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { readAvailable3nvldm7ch5xu5 as readAvailable } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function observable(_this__u8e3s4, context, contentLength, listener) {
  var tmp = GlobalScope_instance;
  return writer(tmp, context, true, observable$slambda(_this__u8e3s4, listener, contentLength)).a4o_1;
}
function observable$slambda($this_observable, $listener, $contentLength) {
  return constructCallableReference(($this$writer, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = get_ByteArrayPool();
    $l$block: {
      // Inline function 'io.ktor.utils.io.pool.useInstance' call
      var instance = tmp0.s4p();
      try {
        var bytesSend = 0n;
        $l$loop: while (!$this_observable.b4n()) {
          var read = yield* readAvailable($this_observable, instance, VOID, VOID, $completion);
          if (read <= 0)
            continue $l$loop;
          yield* writeFully($this$writer.k4o_1, instance, 0, read, $completion);
          // Inline function 'kotlin.Long.plus' call
          var this_0 = bytesSend;
          bytesSend = add(this_0, fromInt(read));
          yield* $listener.q5o(bytesSend, $contentLength, $completion);
        }
        var closedCause = $this_observable.g4m();
        close($this$writer.k4o_1, closedCause);
        if (closedCause == null && bytesSend === 0n) {
          yield* $listener.q5o(bytesSend, $contentLength, $completion);
        }
        break $l$block;
      }finally {
        tmp0.t4p(instance);
      }
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  observable as observable2pw4p3n7s3klf,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
